import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CSVLink } from "react-csv";

import MakeAPICall from "../../apiCalls/common";

import {
  getSupportStaffApiRoute,
  deleteStaffApiRoute,
  blockUnblockStaffApiRoute
} from "../../apiRoutes";

import { getFormattedDate } from "../../utils/dateTimeHelper";
import { sortData } from "../../utils/commonMethods";

import Button from "../../components/button";
import CustomModal from "../../components/modal";

import AddLoginForm from "../../containers/AddLoginForm";
import ActivatePRODADevice from "../../containers/PRODAInterface/activatePRODADevice";
import Loader from "../../components/loader";
import ICPhoneDisplay from "../../components/phoneDisplay";
import CustomDataTable from "../../components/datatable/customDataTable";

import ICNoImg from "../../assets/images/default-picture.png";

const LoginsPage = props => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });
  const [staffs, setStaff] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showUnblockModal, setShowUnblockModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currSelUser, setCurrSelUser] = useState(null);
  const [showSuccModal, setShowSuccModal] = useState(false);
  const [succModalText, setSuccModalText] = useState("");
  const [loginModalTitle, setLoginModalTitle] = useState("");
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalText, setErrModalText] = useState("");
  const [showActivationModal, setShowActivationModal] = useState(false);

  let excelSheetHeader = [
    { label: "Profile Pic", key: "Profile_Pic" },
    { label: "First Name", key: "First_Name" },
    { label: "Middle Name", key: "Middle_Name" },
    { label: "Last Name", key: "Last_Name" },
    { label: "Email", key: "Email" },
    { label: "Phone Number", key: "Phone_Number" },
    { label: "DOB", key: "DOB" },
    { label: "Gender", key: "Gender" },
    { label: "Registration Date", key: "Registration_Date" },
    { label: "User Type", key: "userType" }
  ];

  // get the staff list
  const getSupportStaffData = () => {
    setIsProcessing(true);
    setApiCallParams({
      reqType: "GET",
      reqUrl: getSupportStaffApiRoute,
      params: currFilters,
      successCallback: async res => {
        const auth = props.auth.user;
        let staffList = [];

        let excelSheetList = [];

        await res.data.data.staffs.forEach(column => {
          let d = {};
          let e = {};

          // create the excel sheet export data
          e.Profile_Pic =
            column.profilePic === null ||
            column.profilePic === undefined ||
            column.profilePic === ""
              ? ICNoImg
              : column.profilePic.original;
          e.First_Name = column.firstName ? column.firstName : "NA";
          e.Middle_Name = column.middleName ? column.middleName : "";
          e.Last_Name = column.lastName ? column.lastName : "NA";
          e.Email = column.email;
          e.Phone_Number =
            column.phoneNumber === null ||
            column.phoneNumber === undefined ||
            column.phoneNumber === "" ||
            column.phoneNumber === "undefined"
              ? "NA"
              : column.phoneNumber;
          e.DOB =
            column.dob === null ||
            column.dob === undefined ||
            column.dob === "" ||
            column.dob === "undefined"
              ? "NA"
              : column.dob;
          e.Gender = column.gender === "MALE" ? "Male" : "Female";
          e.Registration_Date = getFormattedDate(column.registrationDate);

          if (column.userType === "SUPPORT_STAFF") {
            e.userType = "Support Staff";
          } else if (column.userType === "SUPER_ADMIN") {
            e.userType = "Super User";
          } else {
            e.userType = "Admin";
          }

          excelSheetList.push(e);

          // create the table display data
          d.disableBlock = false;
          if (auth.email === column.email) {
            d.disableBlock = true;
          }

          d._id = column._id;
          d.dob = column.dob ? column.dob : "NA";
          d.email = column.email;

          if (column.firstName) {
            d.middleName =
              column.middleName === null ||
              column.middleName === undefined ||
              column.middleName.trim() === ""
                ? ""
                : column.middleName;
            d.firstName = column.firstName;
            d.lastName = column.lastName;

            let fullName = column.firstName + " ";

            if (column.middleName && column.middleName.trim().length > 0) {
              fullName = fullName + column.middleName + " ";
            }

            fullName = fullName + column.lastName;

            d.fullName = fullName;
          } else if (column.userName) {
            d.firstName = column.userName;
            d.middleName = " ";
            d.lastName = " ";
            d.fullName = column.userName;
          }

          d.gender = column.gender === "MALE" ? "Male" : "Female";
          d.gender1 = column.gender;
          d.lastLogin = column.lastLogin;
          d.loginCount = column.loginCount;
          d.isBlocked = column.isBlocked;

          d.profilePicOriginal =
            column.profilePic === null ||
            column.profilePic === undefined ||
            column.profilePic === ""
              ? ICNoImg
              : column.profilePic.original;
          d.profilePicThumb =
            column.profilePic === null ||
            column.profilePic === undefined ||
            column.profilePic === ""
              ? ICNoImg
              : column.profilePic.thumb;
          d.registrationDate = getFormattedDate(column.registrationDate);

          d.phoneNumber = column.phoneNumber;
          if (column.userType === "SUPPORT_STAFF") {
            d.userType = "Support Staff";
          } else if (column.userType === "SUPER_ADMIN") {
            d.userType = "Super User";
          } else {
            d.userType = "Admin";
          }
          d.userType1 = column.userType;
          staffList.push(d);
        });
        setStaff(staffList);
        setExcelSheetData(excelSheetList);
        setTotalRecords(res.data.data.count);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  useEffect(() => {
    getSupportStaffData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const selectUser = user => {
    setCurrSelUser(user);
    setShowLoginModal(true);
  };

  const unBlockUser = user => {
    setCurrSelUser(user);
    setShowUnblockModal(true);
  };

  const unBlockCurrSelUser = () => {
    setShowUnblockModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("action", "UNBLOCK");
    setApiCallParams({
      reqType: "PUT",
      reqUrl: blockUnblockStaffApiRoute + currSelUser._id,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        setSuccModalText("User Unblocked Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  const blockUser = user => {
    setCurrSelUser(user);
    setShowBlockModal(true);
  };

  const blockCurrSelUser = () => {
    setShowBlockModal(false);
    setIsProcessing(true);

    let formData = new FormData();
    formData.append("action", "BLOCK");
    setApiCallParams({
      reqType: "PUT",
      reqUrl: blockUnblockStaffApiRoute + currSelUser._id,
      dataObj: formData,
      successCallback: async res => {
        setIsProcessing(false);
        setSuccModalText("User Blocked Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  const deleteUser = user => {
    setCurrSelUser(user);
    setShowDeleteModal(true);
  };

  const deleteCurrSelUser = () => {
    setShowDeleteModal(false);
    setIsProcessing(true);
    setApiCallParams({
      reqType: "DELETE",
      reqUrl: deleteStaffApiRoute + currSelUser._id,
      successCallback: async res => {
        setIsProcessing(false);
        setSuccModalText("User Deleted Successfully");
        setShowSuccModal(true);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setErrModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowErrModal(true);
      }
    });
  };

  const LoginAddedSuccess = () => {
    setShowLoginModal(false);
    let newFilter = Object.assign({}, currFilters);
    newFilter.skip = 0;
    setCurrFilters(newFilter);
    setSuccModalText("Login Added Successfully");
    setShowSuccModal(true);
  };

  const LoginEditSuccess = () => {
    setShowLoginModal(false);
    setSuccModalText("Details Saved Successfully");
    setShowSuccModal(true);
  };

  // create custom table filter function for logins
  const customSearchTableByText = query => {
    let newStaffs = staffs.filter(staff => {
      if (staff.fullName.toLowerCase().includes(query.toLowerCase())) {
        return true;
      } else if (
        staff.phoneNumber.toLowerCase().includes(query.toLowerCase())
      ) {
        return true;
      } else if (staff.email.toLowerCase().includes(query.toLowerCase())) {
        return true;
      } else if (staff.dob.toLowerCase().includes(query.toLowerCase())) {
        return true;
      } else if (staff.gender.toLowerCase().includes(query.toLowerCase())) {
        return true;
      } else if (
        staff.registrationDate.toLowerCase().includes(query.toLowerCase())
      ) {
        return true;
      } else if (staff.userType.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }

      return false;
    });

    setStaff(newStaffs);
  };

  const setTableFilters = filters => {
    if (filters.text && filters.text.length > 0) {
      customSearchTableByText(filters.text);
    } else {
      let newFilter = Object.assign({}, currFilters);
      newFilter.limit = filters.limit;
      newFilter.skip = filters.skip;

      setCurrFilters(newFilter);
    }
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(SelColumn.column, SelColumn.order, staffs);
    setStaff(sortedData);
  };

  const tableHeaders = [
    {
      key: "profilePicOriginal",
      value: "Profile Pic"
    },
    { key: "fullName", value: "Login Details" },
    { key: "dob", value: "DOB" },
    { key: "gender", value: "Gender" },
    { key: "registrationDate", value: "Registered Date" },
    { key: "userType", value: "Login Type" },
    { key: "action", value: "Action" }
  ];

  return (
    <div className="view-ticket-container logins-page-container">
      <CustomModal
        className="modal-lg"
        openModal={showLoginModal}
        title={loginModalTitle}
        modalBodyContent={
          <AddLoginForm
            userData={currSelUser}
            isEditProfile={currSelUser !== null}
            cancelEvent={() => {
              setShowLoginModal(false);
              setCurrSelUser(null);
            }}
            LoginAddedSuccess={LoginAddedSuccess}
            LoginEditSuccess={LoginEditSuccess}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showUnblockModal}
        cancelEvent={() => {
          setShowUnblockModal(false);
          setCurrSelUser(null);
        }}
        okayEvent={unBlockCurrSelUser}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to unblock this user?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showBlockModal}
        cancelEvent={() => {
          setShowBlockModal(false);
          setCurrSelUser(null);
        }}
        okayEvent={blockCurrSelUser}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to block this user?
          </p>
        }
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDeleteModal}
        cancelEvent={() => {
          setShowDeleteModal(false);
          setCurrSelUser(null);
        }}
        okayEvent={deleteCurrSelUser}
        modalBodyContent={
          <p className="text-center mb-0">
            Are you sure you want to delete this user?
          </p>
        }
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showErrModal}
        cancelEvent={() => {
          setShowErrModal(false);
          setErrModalText("");
          setCurrSelUser(null);
        }}
        modalBodyContent={<p className="text-center mb-0">{errModalText}</p>}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showSuccModal}
        cancelEvent={() => {
          setShowSuccModal(false);
          setSuccModalText("");
          setCurrSelUser(null);
          getSupportStaffData();
        }}
        modalBodyContent={<p className="text-center mb-0">{succModalText}</p>}
      />
      <CustomModal
        className="modal-lg text-center"
        openModal={showActivationModal}
        title="PRODA Device Activation"
        noFooterButtons={true}
        modalBodyContent={
          <ActivatePRODADevice
            cancelEvent={() => {
              setShowActivationModal(false);
              setCurrSelUser(null);
            }}
          />
        }
      />

      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="d-flex flex-row flex-wrap justify-content-between">
          <h3>Logins</h3>
          <div className="d-flex flex-row align-items-end">
            <Button
              clickEvent={() => {
                setShowActivationModal(true);
              }}
              title="PRODA Device Activation Code"
            ></Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              clickEvent={() => {
                setLoginModalTitle("Add Login");
                setShowLoginModal(true);
              }}
              title="Add Login"
            ></Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <CSVLink
              className="no-text-decoration"
              filename={"Logins.csv"}
              data={excelSheetData}
              headers={excelSheetHeader}
            >
              <Button title="Export to CSV"></Button>
            </CSVLink>
          </div>
        </div>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {staffs.length > 0 &&
            staffs.map((staff, index) => (
              <tr key={index}>
                <td>
                  <img
                    className="rounded-circle user-img"
                    src={staff.profilePicOriginal}
                    alt="user-img"
                  />
                </td>
                <td className="td-no-hover">
                  <div className="d-flex flex-column">
                    <p className="mb-0">
                      <b>{staff.fullName}</b>
                    </p>
                    <a
                      href={"mailto:" + staff.email}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {staff.email}
                    </a>
                    <p className="mb-0">
                      <ICPhoneDisplay value={staff.phoneNumber} />
                    </p>
                  </div>
                </td>
                <td onClick={() => selectUser(staff)}>{staff.dob}</td>
                <td onClick={() => selectUser(staff)}>{staff.gender}</td>
                <td onClick={() => selectUser(staff)}>
                  {staff.registrationDate}
                </td>
                <td onClick={() => selectUser(staff)}>{staff.userType}</td>
                <td>
                  <div className="d-flex flex-row align-items-center">
                    {staff.isBlocked === false && (
                      <button
                        onClick={() => {
                          if (!staff.disableBlock) blockUser(staff);
                        }}
                        disabled={staff.disableBlock}
                        type="button"
                        className="btn btn-out-green high-z-index"
                      >
                        <i className="fas fa-lock-open"></i>
                      </button>
                    )}
                    {staff.isBlocked === true && (
                      <button
                        onClick={() => {
                          if (!staff.disableBlock) unBlockUser(staff);
                        }}
                        disabled={staff.disableBlock}
                        type="button"
                        className="btn btn-out-delete high-z-index"
                      >
                        <i className="fas fa-lock"></i>
                      </button>
                    )}

                    <button
                      onClick={() => {
                        if (!staff.disableBlock) deleteUser(staff);
                      }}
                      disabled={staff.disableBlock}
                      type="button"
                      className="btn btn-out-delete high-z-index ml-2"
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
        </CustomDataTable>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(LoginsPage);
